export default function Problem() {
    return (
        <section className="problem" id="problem" data-testid="v2-problem">
            <div className="container">
                <div className="problem__head reveal">
                    <span className="problem__eyebrow">The Problem</span>
                    <h2 className="problem__title" data-testid="v2-problem-title">
                        Growth outruns the founder&rsquo;s head.
                    </h2>
                    <p className="problem__sub">
                        Books are done. Meetings happen. Dashboards exist. And yet
                        nobody is <strong>managing</strong> the company &mdash;
                        they&rsquo;re reacting to it. Five predictable failures
                        show up in every growing business.
                    </p>
                </div>

                <div className="problem__grid">
                    {/* 01 · No C-Suite to scale */}
                    <article
                        className="problem__card problem__card--ceo reveal"
                        data-testid="v2-problem-card-1"
                    >
                        <span className="problem__num">
                            <span className="problem__num-dot" aria-hidden="true" />
                            01 &middot; No C-Suite to scale
                        </span>
                        <h3 className="problem__card-title">
                            No CEO, CFO, CMO or CTO steering the business.
                        </h3>
                        <div className="problem__evidence">
                            <span className="problem__severity problem__severity--foundational">
                                <span
                                    className="problem__severity-dot"
                                    aria-hidden="true"
                                />
                                Foundational
                            </span>
                            <span className="problem__evidence-value">
                                90% of MSMEs
                                <span>&middot;</span>
                                No executive layer
                            </span>
                        </div>
                    </article>

                    {/* 02 · Real executives are unaffordable */}
                    <article
                        className="problem__card problem__card--cfo reveal"
                        data-testid="v2-problem-card-2"
                    >
                        <span className="problem__num">
                            <span className="problem__num-dot" aria-hidden="true" />
                            02 &middot; Executives are unaffordable
                        </span>
                        <h3 className="problem__card-title">
                            One C-level costs a year of margin. A full suite
                            costs the company.
                        </h3>
                        <div className="problem__evidence">
                            <span className="problem__severity problem__severity--cost">
                                <span
                                    className="problem__severity-dot"
                                    aria-hidden="true"
                                />
                                Cost-prohibitive
                            </span>
                            <span className="problem__evidence-value">
                                $80K&ndash;$250K per hire
                                <span>&middot;</span>
                                $1M+ full suite
                            </span>
                        </div>
                    </article>

                    {/* 03 · 200K+ businesses close every year */}
                    <article
                        className="problem__card problem__card--critical reveal"
                        data-testid="v2-problem-card-3"
                    >
                        <span className="problem__num">
                            <span className="problem__num-dot" aria-hidden="true" />
                            03 &middot; Preventable shutdowns
                        </span>
                        <h3 className="problem__card-title">
                            200,000+ businesses close every year &mdash; most of
                            it preventable.
                        </h3>
                        <div className="problem__evidence">
                            <span className="problem__severity problem__severity--killer">
                                <span
                                    className="problem__severity-dot"
                                    aria-hidden="true"
                                />
                                Business killer
                            </span>
                            <span className="problem__evidence-value">
                                200,000+ closures/yr
                                <span>&middot;</span>
                                Mostly preventable
                            </span>
                        </div>
                    </article>

                    {/* 04 · Decisions are made blind */}
                    <article
                        className="problem__card problem__card--cto reveal"
                        data-testid="v2-problem-card-4"
                    >
                        <span className="problem__num">
                            <span className="problem__num-dot" aria-hidden="true" />
                            04 &middot; Blind decisions
                        </span>
                        <h3 className="problem__card-title">
                            Cash, pricing, hiring and growth &mdash; all decided
                            without a signal.
                        </h3>
                        <div className="problem__evidence">
                            <span className="problem__severity problem__severity--risky">
                                <span
                                    className="problem__severity-dot"
                                    aria-hidden="true"
                                />
                                Risky
                            </span>
                            <span className="problem__evidence-value">
                                Guesswork on 4 axes
                                <span>&middot;</span>
                                Consequences seen late
                            </span>
                        </div>
                    </article>

                    {/* 05 · Funding remains out of reach */}
                    <article
                        className="problem__card problem__card--cmo reveal"
                        data-testid="v2-problem-card-5"
                    >
                        <span className="problem__num">
                            <span className="problem__num-dot" aria-hidden="true" />
                            05 &middot; Funding out of reach
                        </span>
                        <h3 className="problem__card-title">
                            Only 1% of MSMEs get the capital they need to scale.
                        </h3>
                        <div className="problem__evidence">
                            <span className="problem__severity problem__severity--leakage">
                                <span
                                    className="problem__severity-dot"
                                    aria-hidden="true"
                                />
                                Growth leakage
                            </span>
                            <span className="problem__evidence-value">
                                1% funded
                                <span>&middot;</span>
                                99% under-capitalised
                            </span>
                        </div>
                    </article>
                </div>

                <div
                    className="problem__foot reveal"
                    data-testid="v2-problem-foot"
                >
                    <p className="problem__foot-text">
                        <strong>C-ORE brings C-ORE CEO, CFO, CMO and CTO
                        together</strong> to manage executive operations, drive
                        strategy and execution, prepare your business for
                        funding, and connect you with experts &mdash; all in one
                        place.
                    </p>
                </div>
            </div>
        </section>
    );
}
